import { Ticket } from '@/generated/openapi'
import { InfoPopupBase, InfoPopupData } from '@/models/InfoPopupData'
import { createDefaultPersonalData, PersonalData } from '@/models/PersonalData'
import { persistenceService } from '@/services/persistenceService'
import { now } from '@/utils/dateTimeUtils'
import { DateTime } from 'luxon'
import { createStore } from 'vuex'

export interface StoreState {
  transactionId: string|null;
  transactionExpiration: DateTime|null;
  transactionTickets: Array<Ticket>;
  personalData: PersonalData;
  infoPopupData: InfoPopupData[];
  privacyNotice: boolean;
}

export default createStore({
  state: {
    transactionId: persistenceService.getTransactionId(),
    transactionExpiration: null,
    transactionTickets: [],
    personalData: persistenceService.getPersonalData(),
    infoPopupData: [],
    privacyNotice: persistenceService.getPrivacyNotice()
  } as StoreState,
  mutations: {
    setTransactionId (state, value) {
      state.transactionId = value ? value : null
      persistenceService.setTransactionId(value)
    },
    addTransactionTicket(state, value) {
      state.transactionTickets.push(value)
    },
    setTransactionExpiration(state, value) {
      state.transactionExpiration = value ? value : null
    },
    setTransactionTickets(state, value) {
      state.transactionTickets = value
    },
    clearTransaction(state) {
      state.transactionId = null
      state.transactionTickets = []
      state.transactionExpiration = null
      persistenceService.setTransactionId(null)
    },
    setPersonalData(state, value) {
      state.personalData = value
      persistenceService.setPersonalData(value)
    },
    clearPersonalData(state) {
      state.personalData = createDefaultPersonalData()
      persistenceService.setPersonalData(null);
    },
    addInfoPopup(state, value: InfoPopupBase) {
      state.infoPopupData.push({
        date: now(),
        title: value.title,
        description: value.description,
        type: value.type
      })
    },
    removeLatestInfoPopup(state) {
      state.infoPopupData.shift()
    },
    setPrivacyNotice(state, value: boolean) {
      state.privacyNotice = value
      persistenceService.setPrivacyNotice(value)
    }
  },
  actions: {
  },
  modules: {
  }
})
